import Topo from '../pages/Topo';

function PageWithTopo({ children, assistant, sessionId, selfAssistant = false }) {
  return (
    <>
      <Topo assistant={assistant} sessionId={sessionId} selfAssistant={selfAssistant} />
      {children}
    </>
  );
}

export default PageWithTopo;
